import ReCAPTCHA from "react-google-recaptcha";
import PropTypes from "prop-types";
import { Typography } from "antd";
import { useEffect, useRef } from "react";

function Recaptcha({ recaptchaToken, setRecaptchaToken, recaptchaSiteKey }) {
  const recaptchaRef = useRef(null);

  useEffect(() => {
    if (!recaptchaToken) {
      recaptchaRef.current.reset();
    }
  }, [recaptchaToken]);

  const onCaptchaChange = (key) => {
    setRecaptchaToken(key);
  };

  if (!recaptchaSiteKey) {
    return (
      <Typography.Text type="secondary">Site key not available</Typography.Text>
    );
  }

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={recaptchaSiteKey}
      onChange={onCaptchaChange}
    />
  );
}

Recaptcha.propTypes = {
  recaptchaToken: PropTypes.string,
  setRecaptchaToken: PropTypes.func.isRequired,
  recaptchaSiteKey: PropTypes.string,
};

export { Recaptcha };
